import { Box, Divider, FormControlLabel, FormGroup, Switch, Typography } from '@mui/material';
import type React from 'react';

interface PlatformEcosystemsProps {
  enableBiddingModule: boolean;
  setEnableBiddingModule: (val: boolean) => void;
  enableProcurementModule: boolean;
  setEnableProcurementModule: (val: boolean) => void;
}

export const PlatformEcosystems: React.FC<PlatformEcosystemsProps> = ({
  enableBiddingModule,
  setEnableBiddingModule,
  enableProcurementModule,
  setEnableProcurementModule,
}) => {
  return (
    <>
      <Typography variant="subtitle1" gutterBottom sx={{ fontWeight: 'bold', mt: 4 }}>
        Platform Ecosystems
      </Typography>
      <Divider sx={{ mb: 2 }} />

      <FormGroup>
        <FormControlLabel
          control={
            <Switch
              checked={enableBiddingModule}
              onChange={(e) => setEnableBiddingModule(e.target.checked)}
              name="enableBiddingModule"
              color="primary"
            />
          }
          label={
            <Box>
              <Typography variant="body1">Enable Bidding Module (Sell-Side)</Typography>
              <Typography variant="body2" color="text.secondary">
                Allows this client to use the core Tender/Proposal Writing workspace.
              </Typography>
            </Box>
          }
          sx={{ mb: 2, alignItems: 'flex-start' }}
        />

        <FormControlLabel
          control={
            <Switch
              checked={enableProcurementModule}
              onChange={(e) => setEnableProcurementModule(e.target.checked)}
              name="enableProcurementModule"
              color="primary"
            />
          }
          label={
            <Box>
              <Typography variant="body1">Enable Procurement Module (Buy-Side)</Typography>
              <Typography variant="body2" color="text.secondary">
                Allows this client to use the Procurement and Supplier Evaluation workspace.
              </Typography>
            </Box>
          }
          sx={{ mb: 2, alignItems: 'flex-start' }}
        />
      </FormGroup>
    </>
  );
};
